<template>
  <el-switch ref="rcSwitch" :value="value" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: "RcSwitch",
  props: {
    value: [Boolean, String, Number]
  }
};
</script>
